import { __awaiter, __generator } from "tslib";
import { PermissionStatus, } from '../interfaces/permission';
import { Permission } from './devicePermissionsIndexedDBStorage';
var DevicePermissionStorageService = /** @class */ (function () {
    //deleting database when every capability tries to access devicePermission
    function DevicePermissionStorageService(appID, userID) {
        var _this = this;
        this.appID = appID;
        this.userID = userID;
        this.getPermissions = function () { return __awaiter(_this, void 0, void 0, function () {
            var hasRequestedPermissions, getAllPermission, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Permission.doesRecordExist(this.appID, this.userID)];
                    case 1:
                        hasRequestedPermissions = _a.sent();
                        if (!!hasRequestedPermissions) return [3 /*break*/, 3];
                        return [4 /*yield*/, Permission.createRecord(this.appID, this.userID)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, Permission.searchRecord(this.appID, this.userID, Permission.indexID.APPID_AND_USERID_INDEX)];
                    case 4:
                        getAllPermission = _a.sent();
                        result = Object.entries(getAllPermission[0].permissions).map(function (_a) {
                            var key = _a[0], value = _a[1];
                            return {
                                permission: key,
                                status: value,
                            };
                        });
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.getPermissionStatus = function (permissionType) { return __awaiter(_this, void 0, void 0, function () {
            var permissionList, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPermissions()];
                    case 1:
                        permissionList = _a.sent();
                        result = permissionList.find(function (element) { return element.permission === permissionType; });
                        if (result !== undefined) {
                            return [2 /*return*/, result.status];
                        }
                        else {
                            return [2 /*return*/, PermissionStatus.NeverAsked];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.storePermissionConsent = function (userRespond) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Permission.updatePermission(this.appID, this.userID, userRespond.permission, userRespond.status)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    return DevicePermissionStorageService;
}());
export { DevicePermissionStorageService };
//# sourceMappingURL=defaultPermissionsService.js.map